import { CartLinesUpdateEvent } from "@shopify/events";
import { fetchConfig } from "@theme/utilities";

const euro = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
});

/**
 * THEF: 'Vaak samen gekocht'. Rekent het totaal opnieuw bij elk vinkje en voegt alles in een keer toe
 * via /cart/add.js (items-array), met dezelfde CartLinesUpdateEvent als de koopknop zodat de lade opent.
 */
class ThefBundle extends HTMLElement {
  connectedCallback() {
    this.pct2 = Number(this.dataset.pct2) || 5;
    this.pct3 = Number(this.dataset.pct3) || 10;
    this.addEventListener("change", () => this.update());
    this.querySelector("[data-bundle-add]")?.addEventListener("click", () =>
      this.add(),
    );
    this.update();
  }

  get checked() {
    return [...this.querySelectorAll(".thef-bundle__check")].filter(
      (c) => c.checked,
    );
  }

  update() {
    const items = this.checked;
    const normal = items.reduce((s, c) => s + Number(c.dataset.price), 0);
    const pct =
      items.length >= 3 ? this.pct3 : items.length === 2 ? this.pct2 : 0;
    const total = Math.round((normal * (100 - pct)) / 100);
    const label = this.querySelector("[data-bundle-label]");
    const sum = this.querySelector("[data-bundle-sum]");
    const was = this.querySelector("[data-bundle-was]");
    const btn = this.querySelector("[data-bundle-add]");
    const tx = this.dataset;
    if (label)
      label.textContent = pct
        ? tx.tTogether.replace("__PCT__", pct)
        : tx.tTotal;
    if (sum) sum.textContent = euro.format(total / 100);
    if (was) {
      was.hidden = !pct;
      was.textContent = tx.tWas.replace("__PRICE__", euro.format(normal / 100));
    }
    if (btn) {
      btn.disabled = items.length === 0;
      btn.textContent = items.length === 1 ? tx.tAddOne : tx.tAddAll;
    }
  }

  async add() {
    const items = this.checked;
    const btn = this.querySelector("[data-bundle-add]");
    const err = this.querySelector("[data-bundle-error]");
    if (!items.length || btn?.disabled) return;
    if (err) err.hidden = true;
    btn.disabled = true;
    const body = {
      items: items.map((c) => ({
        id: Number(c.dataset.variantId),
        quantity: 1,
      })),
    };
    const sectionIds = [...document.querySelectorAll("cart-items-component")]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) body.sections = sectionIds.join(",");
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: "add",
        context: "product",
        lines: body.items.map((i) => ({
          merchandiseId: String(i.id),
          quantity: 1,
        })),
        promise: deferred.promise,
      }),
    );
    try {
      const cfg = fetchConfig("javascript", { body: JSON.stringify(body) });
      const response = await fetch(Theme.routes.cart_add_url, {
        ...cfg,
        headers: {
          ...cfg.headers,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }).then((r) => r.json());
      if (response.status) throw new Error(response.description || "add");
      const cart = await fetch(`${Theme.routes.cart_url}.json`).then((r) =>
        r.json(),
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: "thef-bundle",
          itemCount: items.length,
          sections: response.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      if (err) err.hidden = false;
    } finally {
      btn.disabled = false;
      this.update();
    }
  }
}

if (!customElements.get("thef-bundle"))
  customElements.define("thef-bundle", ThefBundle);
